import React from "react";

export default function TrustSafetySection() {
  const features = [
    { icon: "fa-user-check", title: "Verified Drivers & Vehicles" },
    { icon: "fa-file-shield", title: "Document Verification & Admin Approval" },
    { icon: "fa-hand-holding-dollar", title: "Transparent Pricing" },
    { icon: "fa-lock", title: "Secure Digital Payments" },
    { icon: "fa-location-dot", title: "Real-Time Tracking" },
  ];

  return (
    <section className="relative py-24 bg-gradient-to-b from-blue-50 to-white overflow-hidden">
      
      {/* Floating background shapes */}
      <div className="absolute top-0 left-0 w-60 h-60 bg-blue-300 blur-3xl opacity-30 rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-orange-300 blur-3xl opacity-30 rounded-full -z-10"></div>
      <div className="absolute top-1/2 left-1/4 w-48 h-48 bg-green-200 blur-3xl opacity-20 rounded-full -z-10"></div>

      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-h1 md:text-5xl font-extrabold text-trogoBlue mb-3">
          Safety You Can Rely On
        </h2>

        <div className="w-24 h-1 bg-trogoOrange mx-auto mb-6 rounded-full"></div>

        <p className="text-gray-600 max-w-2xl mx-auto mb-12 text-body leading-relaxed">
          Your safety and trust are our top priorities. We ensure every ride and
          delivery is handled securely and reliably.
        </p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
          {features.map((feature, i) => (
            <div
              key={i}
              className="glass-card rounded-3xl p-8 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-trogoOrange/20 mb-4">
                <i className={`fa-solid ${feature.icon} text-trogoOrange text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-trogoBlue text-lg">{feature.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
